import React, { useState, useRef, useEffect } from 'react';

const ApprovedVisitorsList = ({ approvedVs }) => {

  const [atTop, setAtTop] = useState(true);
  const [atBottom, setAtBottom] = useState(false);
  const tbodyWrapRef = useRef(null);

  useEffect(() => {
    const el = tbodyWrapRef.current;
    if (!el) return;
    const check = () => {
      setAtTop(el.scrollTop <= 1);
      setAtBottom(el.scrollTop + el.clientHeight >= el.scrollHeight - 1);
    };
    check();
    el.addEventListener('scroll', check);
    return () => el.removeEventListener('scroll', check);
  }, [approvedVs?.length]);

  function formatDate(date) {
    const formattedDate = new Date(date).toLocaleDateString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: '2-digit',
    });
    return formattedDate.replace(/\//g, '-');
  }

  if (!approvedVs) {
    return <p className="reports-table__empty">Loading previous approvals...</p>;
  }

  const maskImage = (atTop && atBottom)
    ? 'none'
    : atTop
      ? 'linear-gradient(to bottom, black 70%, transparent 100%)'
      : atBottom
        ? 'linear-gradient(to bottom, transparent 0%, black 30%)'
        : 'linear-gradient(to bottom, transparent 0%, black 15%, black 85%, transparent 100%)';

  const colGroup = (
    <colgroup>
      <col className="approve-col--visitor" />
      <col className="approve-col--approver" />
      <col className="approve-col--date" />
    </colgroup>
  );

  return (
    <div className="reports-table-wrap approve__approved-scroll">
      <table className="reports-table">
        {colGroup}
        <thead>
          <tr>
            <th>Visitor</th>
            <th>Approver</th>
            <th>Date</th>
          </tr>
        </thead>
      </table>
      <div
        ref={tbodyWrapRef}
        className="reports-tbody-wrap"
        style={{ maskImage, WebkitMaskImage: maskImage }}
      >
        <table className="reports-table">
          {colGroup}
          <tbody>
            {approvedVs.length === 0 ? (
              <tr>
                <td colSpan={3} className="reports-table__empty">No previously approved visitors.</td>
              </tr>
            ) : approvedVs.map((v, index) => (
              <tr key={index}>
                <td>{v.visitor_first_name} {v.visitor_last_name}</td>
                <td>{v.approver_first_name} {v.approver_last_name}</td>
                <td>{formatDate(v.approve_datetime)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ApprovedVisitorsList;
